module.exports = __webpack_public_path__ + "static/media/icon-menu.f8bd5a86.svg";